import { motion } from "framer-motion";

const ENGINE_IMG =
  "https://images.pexels.com/photos/8478201/pexels-photo-8478201.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const steps = [
  {
    n: "01",
    title: "Describe la pieza",
    desc: "Rellena el formulario con los datos de tu vehículo (marca, modelo, año, matrícula) y dinos qué recambio necesitas. Puedes adjuntar una foto.",
  },
  {
    n: "02",
    title: "Localizamos el mejor recambio",
    desc: "Consultamos en tiempo real con nuestra red de desguaces autorizados y distribuidores en toda España para encontrar la mejor opción.",
  },
  {
    n: "03",
    title: "Recibe presupuesto sin compromiso",
    desc: "Te enviamos el precio final con envío e IVA incluido. Si te encaja, la pieza llega a la puerta de tu taller o de tu casa.",
  },
];

export const HowItWorks = () => (
  <section id="como-funciona" className="relative py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
      <div className="lg:sticky lg:top-28">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-brand-amber mb-4"
        >
          Proceso
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-8"
        >
          De la solicitud<br />a tu taller en<br /><span className="text-brand-orange">3 movimientos</span>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative overflow-hidden rounded-sm border border-industrial-700"
        >
          <img src={ENGINE_IMG} alt="Motor de coche en detalle" className="w-full h-72 sm:h-96 object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-industrial-950/80 to-transparent" />
          <p className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-widest text-brand-amber">
            Verificación mecánica previa al envío
          </p>
        </motion.div>
      </div>

      <div className="flex flex-col">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group border-t border-industrial-700 py-10 flex gap-6 sm:gap-10 items-start hover:bg-industrial-900/50 transition-colors duration-300 px-2 sm:px-4"
            data-testid={`how-step-${s.n}`}
          >
            <span className="font-mono font-bold text-brand-orange text-lg pt-1">{s.n}</span>
            <div>
              <h3 className="font-display font-extrabold uppercase tracking-wide text-2xl sm:text-3xl mb-3 group-hover:text-brand-amber transition-colors duration-300">
                {s.title}
              </h3>
              <p className="text-slate-400 leading-relaxed text-sm sm:text-base max-w-md">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
